import previewSource from '../../public/approval-preview/source.json'

export async function prepareApprovalPreview(extension){
 const legacy=/Chrome\/(\d+)/.exec(navigator.userAgent)
 const compat=legacy&&Number(legacy[1])<70
 const pdf=extension==='pdf',txt=extension==='txt',csv=extension==='csv'
 const base=(process.env.BASE_URL||'/')+'approval-preview/'
 const template=compat?(pdf?'pdf-compat':txt?'text-compat':csv?'csv-compat':'office-compat'):(pdf?'pdf':txt?'text':csv?'csv':'office')
 const script=template==='office'?'viewer.js':template==='office-compat'?'compat-viewer.js':template==='pdf-compat'?'compat-pdf-viewer.js':template==='text-compat'?'compat-text-viewer.js':template==='csv-compat'?'compat-csv-viewer.js':template==='pdf'?'pdf-viewer.js':template==='csv'?'csv-viewer.js':'text-viewer.js'
 const style=script.replace('.js','.css')
 const paths=[base+template+'.html',base+script,base+style]
 // Renderer filenames are stable. Tie their cache key to the bundled source so
 // existing users do not keep an older PDF renderer after a web deployment.
 const version=encodeURIComponent(previewSource.commit)
 const [source,js,css]=await Promise.all(paths.map(async url=>{const r=await fetch(url+'?v='+version);if(!r.ok)throw new Error('预览组件加载失败，请刷新后重试');return r.text()}))
 const bytes=new Uint8Array(16);crypto.getRandomValues(bytes);const nonce=Array.from(bytes,n=>n.toString(16).padStart(2,'0')).join('')
 let html=source.replace("script-src 'self' blob:","script-src 'nonce-"+nonce+"' blob:")
 html=html.replace('<script src="'+script+'"></script>',()=>'<script nonce="'+nonce+'">'+js.replace(/<\/script/gi,'<\\/script')+'</script>')
 html=html.replace('<link rel="stylesheet" href="'+style+'">',()=>'<style>'+css.replace(/<\/style/gi,'<\\/style')+'</style>')
 return {html}
}
